function _throw(customError, e) {
	if (customError.message)
		throw (customError.message)
	throw e;

}

module.exports = _throw;